export default {

    getCargoSegmentAlertStatus: {
        method: 'get',
        url: '/client/dashboard/operation-shipment-leg/cargo-segment-alert-status'
    },
    getDataCargoSegmentAlertStatus: {
        method: 'get',
        url: '/client/dashboard/operation-shipment-leg/data-cargo-segment-alert-status?type=TYPE'
    },
    shipmentOperationStatusForTaskCloseCargo: {
        method: 'get',
        url: '/client/dashboard/operation-shipment-leg/shipment-operation-status-for-task-close-cargo'
    },
    dataShipmentOperationStatusForTaskCloseCargo: {
        method: 'get',
        url: '/client/dashboard/operation-shipment-leg/data-shipment-operation-status-for-task-close-cargo?type=TYPE'
    },

    shipmentOperationStatusForTaskUnloadingYard: {
        method: 'get',
        url: '/client/dashboard/operation-shipment-leg/shipment-operation-status-for-task-unloading-yard'
    },
    dataShipmentOperationStatusForTaskUnloadingYard: {
        method: 'get',
        url: '/client/dashboard/operation-shipment-leg/data-shipment-operation-status-for-task-unloading-yard?type=TYPE'
    }
}
